import type { PLCBaseDTO } from '@/models/dto/plc/plc-base-dto'
import type { BasePLC } from '@/models/types/plc/base-plc'

const mapToBasePLC = (dto: PLCBaseDTO): BasePLC => {
    return {
        id: dto.id,
        name: dto.nome ?? undefined,
        status: dto.stato,
        plcAliasId: dto.idImpiantoPlcAlias ?? undefined,
        facilityId: dto.idImpianto ?? undefined,
        version: dto.versione,
        facilityIconUrl: dto.iconUrl ?? undefined,
        facilityName: dto.nomeImpianto ?? undefined,
        enabled: dto.attivo,
    }
}

const mapToPLCBaseDTO = (plc: BasePLC): PLCBaseDTO => {
    return {
        id: plc.id,
        nome: plc.name ?? null,
        stato: plc.status,
        idImpiantoPlcAlias: plc.plcAliasId ?? null,
        idImpianto: plc.facilityId ?? null,
        versione: plc.version,
        iconUrl: plc.facilityIconUrl ?? null,
        nomeImpianto: plc.facilityName ?? null,
        attivo: plc.enabled,
    }
}

export { mapToBasePLC, mapToPLCBaseDTO }
